'use strict';

var eventmap = [];
var eventname = '';
var ron = /^on/;

for (eventname in global) {
  if (ron.test(eventname)) {
    eventmap.push(eventname.slice(2));
  }
}

module.exports = eventmap;



//////////////////
// WEBPACK FOOTER
// ./~/crossvent/src/eventmap.js
// module id = 115
// module chunks = 0